<script>
  import { createEventDispatcher } from "svelte";

  export let video;
  export let userData;

  const dispatch = createEventDispatcher();
  let title = video.title;
  let videoDescription = video.videoDescription;
  let tags = video.tags.join(", ");

  function handleCloseModal() {
    dispatch("close");
  }

  async function handleSubmit() {
    const formData = { title, videoDescription, tags };
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/videos/update-post/${video._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: userData.token,
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update post");
      }

      const updatedVideo = await response.json();
      dispatch("update", updatedVideo);
      // handleCloseModal();
      window.location.href = `#/video/${video._id}`;
    } catch (error) {
      console.error("Error updating post:", error);
    }
  }
</script>

<div class="modal">
  <div class="modal-content">
    <span class="close" on:click={handleCloseModal}>&times;</span>
    <h2>Edit Post</h2>
    <form on:submit|preventDefault={handleSubmit}>
      <label>
        Title:
        <input type="text" bind:value={title} />
      </label>
      <label>
        Description:
        <textarea bind:value={videoDescription}></textarea>
      </label>
      <label>
        Tags:
        <input type="text" bind:value={tags} />
      </label>
      <button type="submit">Update</button>
    </form>
  </div>
</div>

<style>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* Ensure modal is on top of other content */
  }

  .modal-content {
    background-color: #fefefe;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    max-width: 80%;
    width: 500px; /* Adjust width as needed */
    max-height: 80%;
    overflow-y: auto;
    position: relative;
  }

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    font-size: 1.5rem;
    color: #aaa;
  }

  h2 {
    margin-bottom: 10px;
  }

  form {
    display: flex;
    flex-direction: column;
  }

  label {
    margin-bottom: 10px;
  }

  input,
  textarea {
    width: 100%;
    padding: 8px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  button {
    margin-top: 10px;
    padding: 8px 16px;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  button:hover {
    background-color: #0056b3;
  }
</style>
